import React from 'react';
import { useDashboard } from '../DashboardContext';

const COLORS = ['#6366f1','#0ea5e9','#22c55e','#f59e0b','#ec4899'];

const MostActiveAlumni: React.FC = () => {
    const { leaderboard, loading } = useDashboard();

    return (
        <div className="card h-100">
            <div className="card-header bg-white">
                <div className="fw-semibold font-14">🏆 Most Active Alumni This Period</div>
                <div className="text-muted small">Ranked by weighted activity score</div>
            </div>
            <div className="card-body p-0">
                {loading ? (
                    <div className="placeholder-glow p-3">
                        {[1,2,3,4,5].map(i => (
                            <div key={i} className="d-flex align-items-center gap-3 mb-3">
                                <span className="placeholder rounded-circle" style={{ width: 36, height: 36, display: 'block' }}></span>
                                <div className="flex-1">
                                    <span className="placeholder col-7 d-block mb-1"></span>
                                    <span className="placeholder col-4 d-block"></span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : leaderboard.length === 0 ? (
                    <div className="text-center py-4 text-muted small">No activity data for this period</div>
                ) : (
                    <div className="list-group list-group-flush">
                        {leaderboard.map((alumni: any, i: number) => {
                            const initials = (alumni.name || 'A')
                                .split(' ').slice(0, 2).map((w: string) => w[0]).join('').toUpperCase();
                            return (
                                <div key={alumni.studentId}
                                    className="list-group-item d-flex align-items-center gap-3 px-3 py-2">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white small"
                                        style={{ width: 36, height: 36, background: COLORS[i % COLORS.length], flexShrink: 0 }}>
                                        {initials}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="fw-semibold font-13 text-truncate">{alumni.name}</div>
                                        <div className="text-muted" style={{ fontSize: 11 }}>
                                            {alumni.passOutYear ? `Batch ${alumni.passOutYear} · ` : ''}
                                            {alumni.actionCount} action{alumni.actionCount !== 1 ? 's' : ''}
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <div className="text-muted" style={{ fontSize: 10 }}>#{alumni.rank}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MostActiveAlumni;
